var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Link } from "core/components/Link";
import { Id } from "core/utils";
export var DPGLogo = function (_a) {
    var className = _a.className;
    return (React.createElement(Link, { url: "https://www.dpgmedia.be/nl", target: "_blank", rel: "noopener", className: className, "data-action": Id.action.dpgLogoLink },
        React.createElement(PictureStyled, null,
            React.createElement("source", { srcSet: "/images/logos/dpg.webp", type: "image/webp" }),
            React.createElement("source", { srcSet: "/images/logos/dpg.png", type: "image/png" }),
            React.createElement("img", { src: "/images/logos/dpg.png", alt: "DPGMedia", loading: "lazy" }))));
};
var PictureStyled = styled.picture(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  img {\n    width: 100%;\n    height: auto;\n  }\n"], ["\n  img {\n    width: 100%;\n    height: auto;\n  }\n"])));
var templateObject_1;
